export default {"src":"/_next/static/media/search.36b81d8c.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};